import React from 'react'

const CircledCross = ({color}) => {
  return (
    <svg viewBox="0 0 65 65">
      <path fill={color = '#3F5063'} d="M32,55c-3,0-5.9-0.6-8.6-1.7c-2.7-1.2-5-2.7-7-4.7c-2-2-3.6-4.3-4.7-7C10.6,38.9,10,36,10,33
	c0-3,0.6-5.9,1.7-8.6c1.2-2.7,2.7-5,4.7-7s4.3-3.6,7-4.7C26.1,11.6,29,11,32,11c3,0,5.9,0.6,8.6,1.7c2.7,1.2,5,2.7,7,4.7
	s3.6,4.3,4.7,7C53.4,27.1,54,30,54,33c0,3-0.6,5.9-1.7,8.6c-1.2,2.6-2.7,5-4.7,7c-2,2-4.3,3.6-7,4.7C37.9,54.5,35,55,32,55z M32,13
	c-2.8,0-5.4,0.5-7.8,1.6c-2.4,1.1-4.6,2.5-6.3,4.3s-3.2,3.9-4.3,6.3c-1,2.4-1.6,5-1.6,7.8c0,2.8,0.5,5.4,1.6,7.8
	c1.1,2.4,2.5,4.6,4.3,6.4c1.8,1.8,3.9,3.3,6.3,4.3c2.4,1,5,1.6,7.8,1.6c2.8,0,5.4-0.5,7.8-1.6c2.4-1.1,4.6-2.5,6.3-4.3
	c1.8-1.8,3.2-4,4.3-6.4c1-2.4,1.6-5,1.6-7.8c0-2.8-0.5-5.4-1.6-7.8c-1.1-2.4-2.5-4.6-4.3-6.3s-3.9-3.2-6.3-4.3
	C37.4,13.5,34.8,13,32,13z"/>
      <path fill={color = '#6EC18A'} d="M24.4,42.1c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l16.3-16.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L25.1,41.8
	C24.9,42,24.6,42.1,24.4,42.1z"/>
      <path fill={color = '#6EC18A'} d="M40.6,42.1c-0.3,0-0.5-0.1-0.7-0.3L23.7,25.6c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l16.3,16.3c0.4,0.4,0.4,1,0,1.4
	C41.1,42,40.9,42.1,40.6,42.1z"/>
    </svg>
  )
}

export default CircledCross
